var map = {
	"./index.js": 53,
	"./module.js": 21,
	"./sp-proximity/sp-proximity.component.js": 97,
	"./sp-proximity/sp-proximity.controller.js": 54,
	"./sp-proximity/sp-proximity.scss": 99,
	"./sp-qr/qr-encode.js": 55,
	"./sp-qr/sp-qr.component.js": 101,
	"./sp-qr/sp-qr.controller.js": 56,
	"./sp-qr/sp-qr.scss": 103,
	"./web-socket.service.js": 104
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96;


//////////////////
// WEBPACK FOOTER
// ./src/modules/reverse-ajax \.(js|css|scss)$
// module id = 96
// module chunks = 0 2 3